(async function() {
  "use strict";

  const fetchProduct = async (handle) => {
    try {
      const productHandle = handle || (window.location.pathname.match(/\/products\/(.*)/) || [])[1];
      if (!productHandle) return null;

      const storeUrl = window.slideruleData.storeUrl;
      const productUrl = storeUrl ? `https://${storeUrl}/products/${productHandle}.json` : `/products/${productHandle}.json`;
      const response = await fetch(productUrl);
      const data = await response.json();
      return data ? data.product : null;
    } catch (error) {
      console.log(`SlideRule Analytics: product fetch failed. ${error}.`);
    }
  };

  const fetchCart = async () => {
    try {
      const storeUrl = window.slideruleData.storeUrl;
      const cartUrl = storeUrl ? `https://${storeUrl}/cart.json` : `/cart.json`;
      const response = await fetch(cartUrl);
      return await response.json();
    } catch (error) {
      console.log(`SlideRule Analytics: cart fetch failed. ${error}.`);
    }
  };

  const updateCartAttributes = async (attributes) => {
    try {
      const storeUrl = window.slideruleData.storeUrl;
      const updateUrl = storeUrl ? `https://${storeUrl}/cart/update.json` : `/cart/update.json`;
      const response = await fetch(updateUrl, {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify(attributes)
      });
      return await response.json();
    } catch (error) {
      console.log(`SlideRule Analytics: update cart attributes failed. ${error}.`);
    }
  };

  const formatProduct = (product) => {
    return {
      ...product,
      variants: product.variants.map(variant => ({
        ...variant,
        price: `${variant.price / 100}`,
        price_min: `${variant.price / 100}`,
        price_max: `${variant.price / 100}`,
        compare_at_price: variant.compare_at_price && `${variant.compare_at_price / 100}`
      })),
      product_type: product.type,
      compare_at_price_varies: false,
      images: product.media.map(media => ({
        id: media.id,
        src: `https:${media.preview_image.src}`,
        alt: media.alt
      })),
      image: { src: `https:${product.featured_image}` },
      requires_selling_plan: false,
      selling_plan_groups: [],
      body_html: product.content
    };
  };

  const logAnalyticsEvent = async (event, variantId, quantity) => {
    const cart = await fetchCart();
    const items = cart.items.map(item => ({
      item_id: item.id,
      item_name: item.title,
      affiliation: "Shopify Store",
      currency: cart.currency,
      item_brand: item.vendor,
      item_category: item.product_type,
      item_variant: item.variant_title,
      item_product_id: item.product_id,
      price: Number(item.price),
      quantity: item.quantity,
      sku: item.sku
    }));

    window.slideruleData.analytics.track(event, {
      ecommerce_event: true,
      currency: cart.currency,
      value: items.reduce((total, item) => total + item.price * item.quantity, 0),
      items: items,
      cart_token: cart.token
    });
  };

  const handleCartUpdates = async () => {
    const cart = await fetchCart();
    if (!cart) return;

    const newAttributes = {
      attributes: {
        sra_identifiers: JSON.stringify(cart.items.map(item => item.id)),
        sra_debug: JSON.stringify(cart.items)
      }
    };

    await updateCartAttributes(newAttributes);
    await logAnalyticsEvent("view_cart", null, 1);
  };

  const initCartTracking = async () => {
    document.addEventListener("customViewItem", async (event) => {
      const detail = event.detail;
      if (detail && detail.handle) {
        await fetchProduct(detail.handle);
      }
    });

    const forms = document.querySelectorAll('form[action^="/cart/add"]');
    forms.forEach(form => {
      form.addEventListener("submit", async (event) => {
        event.preventDefault();
        const productVariantId = form.querySelector('input[name="id"]').value;
        const productQuantity = form.querySelector('input[name="quantity"]').value || 1;

        await logAnalyticsEvent("add_to_cart", productVariantId, productQuantity);
        await handleCartUpdates();

        // Submit the form to actually add the item to the cart
        const formData = new FormData(form);
        const storeUrl = window.slideruleData.storeUrl;
        const addUrl = storeUrl ? `https://${storeUrl}/cart/add.js` : `/cart/add.js`;

        await fetch(addUrl, {
          method: 'POST',
          body: formData
        });
      });
    });

    await handleCartUpdates();
  };

  await initCartTracking();
})();



//<script>
  document.addEventListener("DOMContentLoaded", function() {
    var country = "{{ localization.country.iso_code }}";
    if (country !== "GB") {
      var el = document.querySelector(".ge-free-shipping-container");
      if (el) el.style.display = "none";
    }
  });
//</script>

//<script>
  document.addEventListener("DOMContentLoaded", function() {
    var country = "{{ localization.country.iso_code }}";
    if (country !== "GB") {
      var el = document.querySelector(".ge-free-shipping-container-desktop");
      if (el) el.style.display = "none";
    }
  });
//</script>